// 结算通用类型定义

// 账单类型枚举
export enum BillTypeEnum {
  DELIVERY_FEE_BILL = 'DELIVERY_FEE_BILL',
  SLA_BILL = 'SLA_BILL',
  DSP_DELIVERY_FEE_BILL = 'DSP_DELIVERY_FEE_BILL',
  SORTING_BILL = 'SORTING_BILL'
}

// 账单状态枚举（后端完整定义）
export enum BillStatusEnum {
  PRE_GENERATED = 'PRE_GENERATED',
  PENDING_SUMMARY = 'PENDING_SUMMARY',
  INTERNAL_ALREADY = 'INTERNAL_ALREADY',
  ADJUSTMENT_PENDING = 'ADJUSTMENT_PENDING',
  INTERNAL_CONFIRMED = 'INTERNAL_CONFIRMED',
  EXTERNAL_REJECTED = 'EXTERNAL_REJECTED',
  EXTERNAL_CONFIRMED = 'EXTERNAL_CONFIRMED',
  INVOICE_CONFIRMED = 'INVOICE_CONFIRMED',
  PAID = 'PAID',
  LOCKED = 'LOCKED'
}

// 前端可见的账单状态枚举（只包含外部可见状态）
export enum FrontendBillStatusEnum {
  INTERNAL_ALREADY = 'INTERNAL_ALREADY',
  ADJUSTMENT_PENDING = 'ADJUSTMENT_PENDING',
  INTERNAL_CONFIRMED = 'INTERNAL_CONFIRMED',
  EXTERNAL_REJECTED = 'EXTERNAL_REJECTED',
  EXTERNAL_CONFIRMED = 'EXTERNAL_CONFIRMED',
  INVOICE_CONFIRMED = 'INVOICE_CONFIRMED',
  PAID = 'PAID'
}

export interface PageResponseType {
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
  __typename?: string;
}

export interface PageRequestTypeInput {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

/** 账单列表默认分页：按账单 id 降序 */
export const BILL_LIST_DEFAULT_PAGE_REQUEST: PageRequestTypeInput = {
  page: 1,
  size: 20,
  sortBy: 'id',
  sortDirection: 'DESC',
};

export interface TimeRangeInput {
  start?: string;
  end?: string;
}

export interface AdjustmentRecord {
  taskId: string;
  adjustmentType: string;
  adjustmentAmount: number;
  reason: string;
  submitterId: string;
  submittedAt: string;
  status: string;
  __typename?: string;
}

export type AdjustmentType = 'ADD' | 'SUBTRACT' | 'REPLACE';

export type AdjustmentStatus = 'PENDING' | 'CONFIRMED' | 'CANCELLED' | 'REJECTED';
